import { Component, OnInit, AfterViewInit } from "@angular/core";

import { HttpClient } from "@angular/common/http";
import {
  ScrollToConfigOptions,
  ScrollToService,
} from "@nicky-lenaers/ngx-scroll-to";
import { ThemeService } from "../../theme.service";
import { DataService, HomeLink } from "src/app/data.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit, AfterViewInit {
  audio;
  loadAPI: Promise<any>;
  home_links: Array<HomeLink> = [];

  constructor(
    private http: HttpClient,
    private scroll: ScrollToService,
    private router: Router,
    public themeService: ThemeService,
    public dataService: DataService
  ) {
    this.home_links = dataService.home_links;
  }

  ngOnInit() {
    this.audio = new Audio();
  }

  ngAfterViewInit() {
    this.loadAPI = new Promise((resolve) => {
      this.loadScript();
      resolve(true);
    });
    const config: ScrollToConfigOptions = {
      target: "top",
    };

    this.scroll.scrollTo(config);
    return this.http.get("assets/particles.json").subscribe((data) => {});
  }

  jsvoid() {
    void 0;
  }

  loadScript() {
    var isFound = false;
    var scripts = document.getElementsByTagName("script");
    for (var i = 0; i < scripts.length; ++i) {
      if (
        scripts[i].getAttribute("src") != null &&
        scripts[i].getAttribute("src").includes("loader")
      ) {
        isFound = true;
      }
    }

    if (!isFound) {
      var dynamicScripts = ["assets/particles.js"];

      for (var i = 0; i < dynamicScripts.length; i++) {
        let node = document.createElement("script");
        node.src = dynamicScripts[i];
        node.type = "text/javascript";
        node.async = false;
        node.charset = "utf-8";
        document.getElementsByTagName("head")[0].appendChild(node);
      }
    }
  }

  playf() {
    this.audio.src = "../../../assets/name.mp3";
    this.audio.load();
    this.audio.play();
  }

  plays() {
    this.audio.src = "../../../assets/names.mp3";
    this.audio.load();
    this.audio.play();
  }

  delay() {
    return new Promise((resolve) => setTimeout(resolve, 2100));
  }

  navigate = (route: string) => {
    this.router.navigateByUrl(route);
  };
}
